module.exports = __webpack_public_path__ + "static/media/4c_website_logo_sup_beam.516bd712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4c_website_logo_sup_beam.jpg
// module id = 56
// module chunks = 0